import React from 'react';
import {Button, Form, FormGroup, Label, FormText, Container, Row, Col, Badge} from 'reactstrap';
import axios from 'axios';
import "react-table/react-table.css";
import Calendar from 'react-calendar';
import _ from 'lodash';
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';

import '../styles/chat.scss';
import 'react-chat-elements/dist/main.css';
import {MessageBox, Input} from 'react-chat-elements';

import {sendMessage} from '../modules/actions/message'


class Chat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleSendMessage = this.handleSendMessage.bind(this);
    }

    handleSendMessage() {
        let payload = {};
        let result = this.props.dispatch(sendMessage(payload));
    }

    render() {
        return (
            <React.Fragment>
                <MessageBox className="chat"
                            position={'right'}
                            type={'text'}
                            text={'hi hi'}
                            data={{
                                uri: 'https://facebook.github.io/react/img/logo.svg',
                                status: {
                                    click: false,
                                    loading: 0,
                                }
                            }}/>

                <Input className="type-form"
                       placeholder="Type here..."
                       multiline={true}
                       rightButtons={
                           <Button
                               // color='white'
                               backgroundColor='black'
                               text='Send'
                               onClick={this.handleSendMessage.bind(this)}
                           />
                       }/>

                {/*clear text eg:*/}
                {/*<Input*/}
                {/*    ref='input'*/}
                {/*    placeholder="Type here..."/>*/}

                {/*this.refs.input.clear();*/}
            </React.Fragment>


        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(Chat)));
